import { lazy } from "react";
export default {
    SequenceTemplate: lazy(function() {
        return import("./SequenceTemplate/SequenceTemplate");
    }),
    MediaTemplate: lazy(function() {
        return import("./MediaTemplate");
    }),
    DragAndDropTemplate: lazy(function() {
        return import("./DragAndDropTemplate");
    }),
    CatchItTemplate: lazy(function() {
        return import("./CatchItTemplate.react");
    }),
    PinItTemplate: lazy(function() {
        return import("./PinItTemplate.react");
    }),
    PageTemplate: lazy(function() {
        return import("./PageTemplate");
    }),
    SingleChoiceTemplate: lazy(function() {
        return import("./SingleChoiceTemplate");
    }),
    MultipleChoiceDnDTemplate: lazy(function() {
        return import("./MultipleChoiceDnDTemplate");
    }),
    MultipleChoiceTemplate: lazy(function() {
        return import("./MultipleChoiceTemplate");
    }),
    TemplatePageTemplate: lazy(function() {
        return import("./TemplatePageTemplate");
    }),
    ExamTemplate: lazy(function() {
        return import("./Exam");
    }),
    CoreSlideTemplate: lazy(function() {
        return import("./CoreSlideTemplate");
    }),
    ExternalContentTemplate: lazy(function() {
        return import("./ExternalContentTemplate");
    }),
    CompatibleDnDTemplate: lazy(function() {
        return import("./CompatibleDragAndDropWrapper");
    })
};
